import axios from "../axios";
import api from "../api";

export const state = {
  prompts: {
    prompt1: {},
    prompt2: {},
    prompt3: {},
  },
}

export const mutations = {
  SET_PROMPTS_CHURN (state, value) {
    state.prompts = value;
  },
  UPDATE_PROMPT_CHURN (state, {key, value}) {
    state.prompts[key] = value
  }
}
export const actions = {
  async get_prompts_churn ({commit}) {
    try {
      commit('SET_REQ_STATUS', 'loading')
      const { data } = await axios.get(`${api.personalized_emails.settings}/prompts-churn`);
      commit('SET_PROMPTS_CHURN', data);
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async save_prompts_churn ({state, commit}, key) {
    try {
      commit('SET_REQ_STATUS', 'saving')
      await axios.put(`${api.personalized_emails.settings}/prompts-churn`, {[key]: state.prompts[key]});
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  }
}